import StoredLayout from '../../layouts/StoredLayout'
import Tabs from './Tabs'
export default StoredLayout(Tabs)
